module.exports = __webpack_public_path__ + "static/media/userProfile.f1d2328b.svg";